import { Component, OnInit } from '@angular/core';
import { SessionDataService } from '../../services/session-data.service';
import { ActivatedRoute} from '@angular/router';

@Component({
  selector: 'lib-session-listener',
  templateUrl: './session-listener.component.html',
  styleUrls: ['./session-listener.component.css']
})
export class SessionListenerComponent implements OnInit {

  constructor(private sessionDataService:SessionDataService, private route: ActivatedRoute) { }

  events:any[]=[];

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      if(params.loginUrl){
        this.sessionDataService.setLoginUrl(params.loginUrl)
      }
      if(params.token){
        this.sessionDataService.setToken(params.token);
        setTimeout(()=>{
          location.href=location.origin;
        },1000)
      }
      
    })

    window.addEventListener("message",(e)=>{
      this.processEntryMessage(e);
    });
    document.addEventListener("message",(e)=>{
      this.processEntryMessage(e);
    });
  }

  processEntryMessage(e:any){
    const allowedOrigins=this.route.snapshot.data.allowedOrigins;
    if(allowedOrigins && Array.isArray(allowedOrigins) && allowedOrigins.includes(e.origin)){
      const message=JSON.parse(e.data);
      if(message.type=='login' && message.token){
        this.sessionDataService.setToken(message.token);
      }
      if(message.type=='logout'){
        this.sessionDataService.localLogout();
      }
      if(message.type=='loginUrl' && message.loginUrl){
        this.sessionDataService.setLoginUrl(message.loginUrl)
      }
      this.events.push({
        origin:e.origin,
        valid:true,
        data:e.data
      });
      if(message.redirectUrl){
        setTimeout(()=>{
          window.location.href=message.redirectUrl;
        },message.redirectTimeout || 1000);
      }
    }
    else{
      this.events.push({
        origin:e.origin,
        valid:false,
        data:(Array.isArray(allowedOrigins))?allowedOrigins.join(','):""
      })
    }
    
  }

}
